import RenderWrapper from 'features/shared/components/renderWrapper/RenderWrapper';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  enableDescription?: boolean;
}

const RequirementSimplifiedHeader = ({ enableDescription = false }: Props) => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  return (
    <div className="d-none d-sm-block mb-2 text-muted font-weight-bold">
      <div className="row no-gutters align-items-center px-3 mr-5">
        <div className="col-auto col-sm-3 col-lg-2 pr-2">
          {tLabels("requirementSimplifiedHeader.date")}
        </div>
        <div className="col-auto col-sm-3 col-lg-2 pr-sm-2 text-truncate">
          {tLabels("requirementSimplifiedHeader.number")}
        </div>
        <div className="col-sm-6 col-lg-8">
          <div className="row no-gutters align-items-center">
            <div className={`col-auto px-lg-3 col-lg-6${enableDescription ? " col-xl-4" : ""}`}>
              {tLabels("requirementSimplifiedHeader.type")}
            </div>
            <div className="col-auto d-lg-none">/</div>
            <div className={`col-auto col-lg-6${enableDescription ? " col-xl-3" : ""}`}>
              {tLabels("requirementSimplifiedHeader.state")}
            </div>
            <RenderWrapper isVisible={() => enableDescription}>
              <div className="d-none d-xl-block col-xl-5 pl-lg-4">
                {tLabels("requirementSimplifiedHeader.description")}
              </div>
            </RenderWrapper>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RequirementSimplifiedHeader;
